import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progestao',
  templateUrl: './progestao.component.html',
  styleUrls: ['./progestao.component.css']
})
export class ProgestaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
